import { render, staticRenderFns } from "./ticket-infos.vue?vue&type=template&id=6766b1b8&scoped=true"
import script from "./ticket-infos.vue?vue&type=script&lang=js"
export * from "./ticket-infos.vue?vue&type=script&lang=js"
import style0 from "./ticket-infos.vue?vue&type=style&index=0&id=6766b1b8&prod&lang=css"
import style1 from "./ticket-infos.vue?vue&type=style&index=1&id=6766b1b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6766b1b8",
  null
  
)

export default component.exports